import { Controller } from "@hotwired/stimulus";

/**
 * Theme controller for toggling between light and dark themes.
 * Saves preference to localStorage and updates the data-theme attribute on the html element.
 *
 * Example:
 *   <button
 *     type="button"
 *     data-controller="theme"
 *     data-action="click->theme#toggle"
 *   >
 *     <span data-theme-target="icon">Icon</span>
 *   </button>
 */
export default class extends Controller {
  static targets = ["icon"];

  connect() {
    this.initializeTheme();
  }

  initializeTheme() {
    const savedTheme = localStorage.getItem("theme");
    const theme = savedTheme || "light";
    this.setTheme(theme);
  }

  toggle() {
    const currentTheme = document.documentElement.getAttribute("data-theme") || "light";
    const newTheme = currentTheme === "light" ? "dark" : "light";
    this.setTheme(newTheme);
  }

  setTheme(theme) {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }
}
